import { render } from "./PersonalNoteButton.vue?vue&type=template&id=01216c9e"
import script from "./PersonalNoteButton.vue?vue&type=script&lang=js"
export * from "./PersonalNoteButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__